// Phase 31 Plan 31-04 Task 2 — terminal `_affinity_reveal` sidecar atom.
//
// The match-end "affinity reveal" payload arrives as a sidecar field on the
// TURN_APPLIED frame's `your_state_json` (alongside, but NOT part of, the
// PlayerView). The ws-client (Plan 31-04 Task 2 modification) strips the
// sidecar BEFORE casting the rest as PlayerView and pushes the reveal payload
// into this atom; WinOverlay subscribes via `useStore($affinityReveal)`.
//
// Why a separate atom (vs. extending PlayerView):
// - Sidecar payload is terminal-only — it lives on the FINAL frame, never on
//   intermediate snapshots. Pushing it through the PlayerView channel would
//   pollute the schema with a field that's null 99% of the time.
// - B12 firewall: putting opponent affinity letters on PlayerView would
//   require a new "opponent.*" field, breaking the T-31-01 web-side grep
//   gate. Sidecar lives outside the PlayerView surface entirely.
// - Single-consumer: only WinOverlay needs this payload, so a dedicated
//   atom is the minimum-coupling pattern.

import { atom } from 'nanostores'

export interface AffinityReveal {
  /** Player A's (slot 0) 4-letter affinity tuple. */
  readonly a: readonly [string, string, string, string]
  /** Player B's (slot 1) 4-letter affinity tuple. */
  readonly b: readonly [string, string, string, string]
}

export const $affinityReveal = atom<AffinityReveal | null>(null)
